module.exports = __webpack_public_path__ + "img/martinez.87b1efae.jpg";